
import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    marca: '',
    modelo: '',
    año: '',
    estado: '',
    mensaje: ''
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    // Construir mensaje de WhatsApp
    const whatsappMessage = 
      `Hola Desguaces Castelldefels, me interesa vender mi coche. Aquí están mis datos:\n\n` +
      `👤 Nombre: ${formData.nombre}\n` +
      `📧 Email: ${formData.email}\n` +
      `📱 Teléfono: ${formData.telefono}\n\n` +
      `🚗 Marca: ${formData.marca}\n` +
      `📋 Modelo: ${formData.modelo}\n` +
      `📅 Año: ${formData.año}\n` +
      `🔧 Estado: ${formData.estado}\n` +
      (formData.mensaje ? `\n💬 Información adicional:\n${formData.mensaje}` : '') +
      `\n\n¿Podrían darme una valoración?`;

    const whatsappUrl = `https://wa.me/34932932913?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="valoracion" className="py-12 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-orange-100 text-orange-700 rounded-full mb-3 sm:mb-4">
            <i className="ri-calculator-line text-base sm:text-lg"></i>
            <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">VALORACIÓN GRATUITA</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            ¿Cuánto Vale tu Coche? <strong>Valoración Gratis</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Rellena el formulario y envíanos tus datos por WhatsApp. Te daremos una valoración en menos de 1 hora.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* Contact Form */}
          <div>
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                <div>
                  <label htmlFor="nombre" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                    Nombre completo *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    required
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="Tu nombre"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="tu@email.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="telefono" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  required
                  value={formData.telefono}
                  onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                  placeholder="+34 XXX XXX XXX"
                />
              </div>

              <div className="grid grid-cols-3 gap-3 sm:gap-6">
                <div>
                  <label htmlFor="marca" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                    Marca *
                  </label>
                  <input
                    type="text"
                    id="marca"
                    name="marca"
                    required
                    value={formData.marca}
                    onChange={(e) => setFormData({ ...formData, marca: e.target.value })}
                    className="w-full px-2 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="Seat"
                  />
                </div>
                <div>
                  <label htmlFor="modelo" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                    Modelo *
                  </label>
                  <input
                    type="text"
                    id="modelo"
                    name="modelo"
                    required
                    value={formData.modelo}
                    onChange={(e) => setFormData({ ...formData, modelo: e.target.value })}
                    className="w-full px-2 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="Ibiza"
                  />
                </div>
                <div>
                  <label htmlFor="año" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                    Año *
                  </label>
                  <input
                    type="text"
                    id="año"
                    name="año"
                    required
                    value={formData.año}
                    onChange={(e) => setFormData({ ...formData, año: e.target.value })}
                    className="w-full px-2 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                    placeholder="2010"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="estado" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                  Estado del vehículo *
                </label>
                <select
                  id="estado"
                  name="estado"
                  required
                  value={formData.estado}
                  onChange={(e) => setFormData({ ...formData, estado: e.target.value })}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all text-sm"
                >
                  <option value="">Selecciona el estado</option>
                  <option value="Funciona correctamente">Funciona correctamente</option>
                  <option value="Averiado pero arranca">Averiado pero arranca</option>
                  <option value="No arranca">No arranca</option>
                  <option value="Accidentado">Accidentado</option>
                  <option value="Sin ITV">Sin ITV</option>
                  <option value="Para desguace">Para desguace</option>
                </select>
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-xs sm:text-sm font-semibold text-gray-700 mb-1.5 sm:mb-2">
                  Información adicional
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  rows={3}
                  maxLength={500}
                  value={formData.mensaje}
                  onChange={(e) => setFormData({ ...formData, mensaje: e.target.value })}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all resize-none text-sm"
                  placeholder="Cuéntanos más sobre el estado del coche, kilómetros, daños, etc... (máximo 500 caracteres)"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">{formData.mensaje.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                className="w-full flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-green-500 text-white rounded-lg font-semibold hover:bg-green-600 transition-colors whitespace-nowrap text-sm sm:text-base"
              >
                <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
                Enviar por WhatsApp
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-4 sm:space-y-8">
            {/* Why Sell With Us */}
            <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl sm:rounded-2xl p-5 sm:p-8 text-white">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-4 sm:mb-6">¿Por qué vendernos tu coche?</h3>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-checkbox-circle-fill text-xl sm:text-2xl flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-sm sm:text-base">Pago inmediato en efectivo o transferencia</p>
                    <p className="text-xs sm:text-sm text-white/80">Sin esperas ni complicaciones</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-checkbox-circle-fill text-xl sm:text-2xl flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-sm sm:text-base">Recogida gratuita en Castelldefels</p>
                    <p className="text-xs sm:text-sm text-white/80">Incluye servicio de grúa</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-checkbox-circle-fill text-xl sm:text-2xl flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-sm sm:text-base">Gestión completa de baja en DGT</p>
                    <p className="text-xs sm:text-sm text-white/80">Certificado oficial incluido</p>
                  </div>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-checkbox-circle-fill text-xl sm:text-2xl flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-sm sm:text-base">Compramos cualquier vehículo</p>
                    <p className="text-xs sm:text-sm text-white/80">Accidentado, averiado o sin ITV</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Cards */}
            <div className="space-y-3 sm:space-y-4">
              <div className="bg-gray-50 rounded-lg sm:rounded-xl p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-xl sm:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Teléfono</h3>
                    <a href="tel:+34932932913" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap text-sm sm:text-base">
                      +34 932 932 913
                    </a>
                    <p className="text-xs sm:text-sm text-gray-600 mt-1">Lunes a Viernes: 9:00 - 19:00</p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg sm:rounded-xl p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl sm:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">WhatsApp</h3>
                    <a href="https://wa.me/34932932913" target="_blank" rel="nofollow noopener noreferrer" className="text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap text-sm sm:text-base">
                      Enviar mensaje
                    </a>
                    <p className="text-xs sm:text-sm text-gray-600 mt-1">Respuesta inmediata</p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg sm:rounded-xl p-4 sm:p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-xl sm:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Dirección</h3>
                    <p className="text-gray-700 text-sm">Calle Industrial, Polígono</p>
                    <p className="text-gray-700 text-sm">08860 Castelldefels, Barcelona</p>
                    <a href="https://maps.google.com" target="_blank" rel="nofollow noopener noreferrer" className="text-teal-600 hover:text-teal-700 text-xs sm:text-sm font-medium mt-2 inline-block whitespace-nowrap">
                      Ver en Google Maps →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
